import { finite } from './sessions/gait-total.js'

// The API can hand `day_count` back as a string (e.g. "5"); summing strings
// concatenates them ("0" + "5" + "3" = "053") and shifts every step date.
export const toDayCount = finite

export const sumDayCount = (steps) => (steps ?? []).reduce((total, step) => total + toDayCount(step?.day_count), 0)

export const withNumericDayCount = (item) => ({ ...item, day_count: toDayCount(item?.day_count) })
